// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.units.RentalManagerUserPropertyFloorPlanUnitWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete,
  RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit,
  RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  EditUnitRequestDto,
  UpdateVideoForUnitDto,
  UserPropertyDetailsFloorPlanUnitDto,
  UserPropertyFloorPlanUnitCreateCompleteRequestWebDto,
  UserPropertyFloorPlanUnitCreateCompleteResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

export interface RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete_Args {
  postData: UserPropertyFloorPlanUnitCreateCompleteRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete_Options = UseMutationOptions<
  UserPropertyFloorPlanUnitCreateCompleteResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete_Args
>;

/**
 * Create a unit with all fields for a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete_Args) =>
      RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit_Args {
  postData: EditUnitRequestDto;
}

export type RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit_Options = UseMutationOptions<
  UserPropertyDetailsFloorPlanUnitDto,
  unknown,
  RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit_Args
>;

/**
 * Edit a unit
 */
export const useRentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit_Args) =>
      RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl_Args {
  postData: UpdateVideoForUnitDto;
}

export type RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl_Args
>;

/**
 * Update video URL of a unit within a property
 */
export const useRentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl_Args) =>
      RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl(args.postData, httpClient),
  });
};
